/**
 * 클래스 생성 직후 진입 표식(sessionStorage, 값은 클래스 id). role 확정 전엔 본문이 마운트되지
 * 않아 URL 쿼리 대신 세션에 두고, 집어 간 쪽(학생 탭)이 id 를 대조한 뒤 즉시 지운다.
 */
export const CLASSROOM_ADD_STUDENT_ON_ENTER_KEY =
  'classroom-add-student-on-enter';
